module.exports = __webpack_public_path__ + "02_face.fb742797.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer1/02_face.png
// module id = 6Wlv
// module chunks = 0